import { useTranslations } from '@vocab/react';
import {
  Actions,
  Button,
  Dialog,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';
import React from 'react';

import translations from 'src/App/Components/RemoveUserDialog/.vocab';
import type {
  CurrentAdvertiserContext,
  User,
  UserDetails,
} from 'src/graphql/generated';
import { useAccountContext } from 'src/hooks/use-account-context';
import { trackClickDeleteUserConfirmationYes } from 'src/utils/trackingUserActions';

export type UserToRemove = User | UserDetails;

export interface RemoveUserDialogProps {
  userToRemove: UserToRemove | null;
  removeUser: (user: UserToRemove) => void;
  setUserToRemove: (user: UserToRemove | null) => void;
}

export const RemoveUserDialog = ({
  userToRemove,
  removeUser,
  setUserToRemove,
}: RemoveUserDialogProps) => {
  const { data: accountData } = useAccountContext();
  const currentAdvertiser = accountData?.currentAdvertiser as
    | CurrentAdvertiserContext
    | undefined;
  const { t } = useTranslations(translations);
  return (
    <Dialog
      id="delete-confirmation"
      title={t('Remove team member dialog title')}
      open={userToRemove !== null}
      onClose={() => {
        setUserToRemove(null);
      }}
      width="xsmall"
    >
      <Stack space="small">
        <Text
          weight="strong"
          data={{ 'dd-privacy': 'mask', 'hj-masked': true }}
        >
          {userToRemove?.firstName} {userToRemove?.lastName}
        </Text>
        <Text data={{ 'dd-privacy': 'mask' }}>{userToRemove?.email}</Text>
      </Stack>
      <Text>
        {t('Remove team member description')}{' '}
        <Strong>
          {currentAdvertiser?.name} ({currentAdvertiser?.billingId})
        </Strong>
      </Text>
      <Actions>
        <Button
          tone="critical"
          onClick={() => {
            if (userToRemove) {
              trackClickDeleteUserConfirmationYes(userToRemove.id);
              removeUser(userToRemove);
            }
          }}
          data={{ testid: 'remove-team-member-dialog' }}
        >
          {t('Remove team member button')}
        </Button>
      </Actions>
    </Dialog>
  );
};
